/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Reports Icon component.
 */
export const SideNavReportsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19152)'>
        <rect x='2' y='6.80957' width='4.76196' height='12.3811' rx='0.5' stroke={iconColor} strokeWidth='1.5' />
        <path d='M10.2617 3.5C10.2617 3.22386 10.4856 3 10.7617 3H14.5237C14.7998 3 15.0237 3.22386 15.0237 3.5V18.6907C15.0237 18.9668 14.7998 19.1907 14.5237 19.1907H10.7617C10.4856 19.1907 10.2617 18.9668 10.2617 18.6907V3.5Z' stroke={iconColor} strokeWidth='1.5' />
        <path d='M18.5234 10.166C18.5234 9.88987 18.7473 9.66602 19.0234 9.66602H22.7854C23.0615 9.66602 23.2854 9.88987 23.2854 10.166V18.6899C23.2854 18.9661 23.0615 19.1899 22.7854 19.1899H19.0234C18.7473 19.1899 18.5234 18.9661 18.5234 18.6899V10.166Z' stroke={iconColor} strokeWidth='1.5' />
      </g>
      <defs>
        <clipPath id='clip0_14304_19152'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SideNavReportsIcon;
